module.exports = __webpack_public_path__ + "static/media/2.c1f1f2dd.png";